import { render, staticRenderFns } from "./LiberacionProduccion.vue?vue&type=template&id=5fc9c289&"
import script from "./LiberacionProduccion.vue?vue&type=script&lang=js&"
export * from "./LiberacionProduccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports